module.exports = __webpack_public_path__ + "static/media/tag.fc5387ba.png";